import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';

/**
 * Path-based tenancy: when the app is scoped to /w/<slug>, tell the API which
 * workspace every request belongs to via X-Tenant-Key. Marketing / login /
 * super-admin pages send nothing and the API falls back to its default.
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const slug = inject(TenantService).currentSlug;
  if (slug && !req.headers.has('X-Tenant-Key')) {
    return next(req.clone({ setHeaders: { 'X-Tenant-Key': slug } }));
  }
  return next(req);
};
